// Text / labels
export const MESSAGE_MODAL_TEXT = {
  DEFAULT_TITLE: "Message payload",
  CLOSE_ACTION: "Close",
  NAVIGATION_HINT: "Use ↑ / ↓ arrows to navigate messages, Esc to close",
};

// UI config
export const MESSAGE_MODAL_CONFIG = {
  HINT_Z_INDEX: 1301,
};
